import { render, staticRenderFns } from "./WHSManagementPlan.vue?vue&type=template&id=00bc0706&"
import script from "./WHSManagementPlan.vue?vue&type=script&lang=js&"
export * from "./WHSManagementPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports